import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  const containerTopCommon = {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: theme.spacing(5),
  };

  return {
    settingsButton: {
      alignItems: 'right',
    },
    container: {
      position: 'absolute',
      right: theme.spacing(4),
      top: theme.spacing(0.5),
    },
    containerBottom: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      textAlign: 'center',
      backgroundColor: 'rgba(230, 230, 230, 0.7)',
      zIndex: 5,
    },
    containerTop: {
      ...containerTopCommon,
      backgroundColor: 'rgba(255,255,255,0.7)',
      zIndex: 5,
    },
    containerTopMask: {
      ...containerTopCommon,
      backgroundColor: 'white',
    },
    title: {
      flexGrow: 1,
      paddingRight: theme.spacing(1),
    },
    titleContent: {
      height: theme.spacing(2),
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
  };
};
